import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';

@Injectable()
export class ModalsService {
  public modalData: any;

  constructor(public sharedService: SharedService) {
    this.modalData = { visible: false };
  }

  showModal(modalData: any) {
    this.modalData = {
      visible: true,
      component: modalData.component,
      title: modalData.title,
    };
    if (modalData.data) {
      this.modalData.data = modalData.data;
    }
    this.sharedService.modalState = true;
    this.sharedService.toggleDocumentScroll(false);
    this.sharedService.sendMessage('MODAL_SHOW', modalData);
  }

  hideModal(source: string = 'cancel') {
    this.modalData.visible = false;
    this.sharedService.modalState = false;
    this.sharedService.toggleDocumentScroll(true);
    this.sharedService.sendMessage('MODAL_HIDE', {
      component: this.modalData.component,
      source: source,
    });
    setTimeout(() => {
      this.modalData = { visible: false };
    }, 500);
  }
}
